import React, { useState, useContext, useEffect, useRef } from "react";
import debounce from "lodash.debounce";
import { useParams, useNavigate } from "react-router-dom";
import callAPI from "../../../../../../api/apiCaller";
import { Context } from "../../../../../../Store";
import Checkbox from "../../../../../../common/Checkbox";
import Accordian from "../../../../../../common/Accordian";
import {
  NameContainer,
  AvatarInfo,
  Avatar,
  AvatarName,
  DateTag,
  DropIcon,
  DropdownItems,
  DropdownButton,
  MentorsContainerOuter,
  MentorsHead,
  BackButton,
  ButtonText,
  MentorsBottom,
  MentorsHeading,
  SearchBoxFilterContainer,
  SearchParticipantsWrapper,
  FilterOption,
  FilterText,
  FilterOptions,
  FilterBy,
  FilterHeadText,
  FilterLabel,
  FilterLabelText,
  FilterClear,
  FilterButtons,
  ResetButton,
  DateInputs,
  ApplyButton,
  ProfileImageContainer,
  ProfileImage,
  ProfileHidden,
  List,
  Participant,
  ListInner,
  ParticipantInfo,
  ParticipantImage,
  ParticipantInfoDescription,
  ParticipantName,
  ParticipantRole,
  ParticipantDetails,
  ParticipantActions,
  ParticipantMembers,
  Select,
  Option,
  TableContainer,
  MentorDescription,
  MentorsInfo,
  ExportDeleteBtnContainer,
  FilterContainer,
  ExportContainer,
  Export,
  ExportText,
  ExportOptions,
  ExportOption,
  NotFoundMessage,
} from "./styles";
import { Info } from "../ActiveParticipants/styles";
import { formatDateForMeetings } from "../../../../../../common/utils";
import {
  AngleSpan,
  CurrentPage,
  NextButton,
  PaginationButtons,
  PaginationSpan,
  PreviousButton,
  ResultsLabel,
  ResultsSelect,
  TableActions,
  TablePagination,
} from "../../../../../../common/Table/styles";
import Modal from "../../../../../../common/Modal";
import Icon from "../../../../../../common/Icon";
import Button from "../../../../../../common/Button";
import {
  ButtonSpacer,
  SectionActions,
} from "../../../../../../common/Button/styles";
import PaginatedTable from "../../../../../../common/Table/PaginatedTable";
import TextInput from "../../../../../../common/TextInput";
import EnhancedDateRangePicker from "../../../../../../common/DatePicker";
import DropDown from "../../../../../../common/drop-down/DropDown";
import Table from "../../../../../../common/Table";
import AggregatorModal from "../modals/AggregatorModal";
import ApplicationModal from "../modals/ApplicationModal";
import Loading from "../../../../../../common/Loading";
import { ExportCSV } from "../../../../../../common/utils";

const Mentors = ({ setSwitchToParticipants, joinAs }) => {
  const params = useParams();
  const navigate = useNavigate();
  const { dispatch } = useContext(Context);
  const [mentorParticipant, setMentorParticipant] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(1);
  const [actionButtons, setActionButtons] = useState(null);
  // const [isDeleteModal, setIsDeleteModal] = useState(false);
  // const [isViewMore, setIsviewMore] = useState(false);
  const [filterOptions, setFilterOptions] = useState(false);
  const [ranking, setRanking] = useState(0);
  const [clickedParticipant, setClickedParticipant] = useState(null);
  const [searchParticipant, setSearchParticipant] = useState("");
  const [dateRange, setDateRange] = useState({ from: null, to: null });
  const [hourRangeTo, setHourRangeTo] = useState(null);
  const [hourRangeFrom, setHourRangeFrom] = useState(null);
  const [status, setStatus] = useState("");
  const [participantLength, setParticipantLength] = useState(0);
  const [loading, setLoading] = useState(true);
  const [applicationModal, setApplicationModal] = useState(null);
  const [isOpenApplicationModal, setIsOpenApplicationModal] = useState(false);
  const [resetFilter, setResetFilter] = useState(false);

  const handleChange = (event) => {
    setStatus(event.target.value);
  };

  const formatDateTime = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(d.getDate()).padStart(2, "0")}`;
  };

  const getMentorParticipantOpenNetworking = () => {
    setLoading(true);

    const data = {
      programId: params.selectedProgram,
      page: page,
      limit: pageSize,
      joinAs,
      search: searchParticipant?.trim() === "" ? null : searchParticipant,
      fromHours: hourRangeFrom?.trim() === "" ? null : hourRangeFrom,
      toHours: hourRangeTo?.trim() === "" ? null : hourRangeTo,
      fromCreatedAt: formatDateTime(dateRange.from),
      toCreatedAt: formatDateTime(dateRange.to),
      status: status?.trim() === "" ? null : status,
    };
    callAPI(dispatch, "getMentorParticipantsOpenNetworking", data)
      .then((res) => {
        if (res) {
          setMentorParticipant(res.data);
          setCount(res.total);
          setRanking((page - 1) * pageSize + 1);
          setParticipantLength(res.total);
        }
      })
      .finally(() => setLoading(false));

    clearSelectedHandler();
  };

  useEffect(() => {
    getMentorParticipantOpenNetworking();

    clearSelectedHandler();
  }, [searchParticipant, pageSize, page, isOpenApplicationModal]);

  const handleMenteeClick = (mentorId) => {
    setClickedParticipant((prevId) => (prevId === mentorId ? null : mentorId));
  };

  const resetFilters = () => {
    setDateRange({ from: null, to: null });
    setHourRangeTo(null);
    setHourRangeFrom(null);
    setStatus("");

    if (
      dateRange?.from ||
      dateRange?.to ||
      hourRangeFrom ||
      hourRangeTo ||
      status
    ) {
      setResetFilter(true);
    }
  };

  // Watch for changes in filters and trigger API call
  useEffect(() => {
    if (
      dateRange?.from === null &&
      dateRange?.to === null &&
      hourRangeFrom === null &&
      hourRangeTo === null &&
      status === "" &&
      resetFilter
    ) {
      setResetFilter(false);
      getMentorParticipantOpenNetworking();
    }
  }, [dateRange, hourRangeFrom, hourRangeTo, status]);

  const applyFilters = () => {
    getMentorParticipantOpenNetworking();
  };

  const ParticipantList = ({
    participant,
    totalParticipants,
    participantClickedId,
    participantClicked,
  }) => {
    // const maxVisible = 5;
    // const visibleMentees = participant ;
    // const hiddenCount = participant ;
    return (
      <ProfileImageContainer>
        {participant?.map((participant, index) => (
          <ProfileImage
            key={index}
            src={
              participant?.participant?.image
                ? participant?.participant?.image
                : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
            }
            alt={participant?.participant?.firstName}
            onClick={() => handleMenteeClick(participantClickedId)}
          />
        ))}
        {/* {hiddenCount > 0 && <ProfileHidden>+{hiddenCount}</ProfileHidden>} */}
        {participantClicked.id === clickedParticipant && (
          <List>
            <ListInner>
              <Participant>
                <ParticipantInfo>
                  <ParticipantImage
                    src={
                      participantClicked.participant.image
                        ? participantClicked.participant.image
                        : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                    }
                  />
                  <ParticipantInfoDescription>
                    <ParticipantName>
                      {participantClicked.participant.firstName}{" "}
                      {participantClicked.participant.lastName}
                    </ParticipantName>
                    <ParticipantRole>
                      {participantClicked.joinAs}
                    </ParticipantRole>
                  </ParticipantInfoDescription>
                </ParticipantInfo>
                <ParticipantDetails>
                  Total Tracked Hours: {participantClicked?.totalTrackHours} |
                  Total {participantClicked.mentees ? "Mentees" : "Mentors"}:{" "}
                  {participantClicked.mentees
                    ? participantClicked.mentees.length
                    : participantClicked.mentors.length}
                </ParticipantDetails>
                <ParticipantActions>
                  <Button
                    icon="chat"
                    onClick={() => {
                      callAPI(
                        dispatch,
                        "initializeConversation"
                        // { id: mentee?.participant.id }
                      )
                        .then((res) => {
                          if (res) {
                            // navigate(
                            //   `/messages/${mentee?.participant.uuid}`
                            // );
                            navigate(
                              `/messages/${participantClicked?.participant?.uuid}`
                            );
                          }
                        })
                        .catch((error) => {
                          //console.error(error);
                        });
                    }}
                    // onClick={() => {
                    //   navigate(
                    //     `/messages/${participantClicked?.participant?.uuid}`
                    //   );
                    // }}
                  />
                </ParticipantActions>
              </Participant>
              <ParticipantMembers>
                {totalParticipants &&
                  totalParticipants.map((participant, index) => {
                    return (
                      <Participant isMembers={true}>
                        <ParticipantInfo>
                          <ParticipantImage
                            src={
                              participant.participant.image
                                ? participant.participant.image
                                : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                            }
                          />
                          <ParticipantInfoDescription>
                            <ParticipantName>
                              {participant.participant.firstName}{" "}
                              {participant.participant.lastName}
                            </ParticipantName>
                            <ParticipantRole>
                              {participant.joinAs}
                            </ParticipantRole>
                          </ParticipantInfoDescription>
                        </ParticipantInfo>
                        <ParticipantDetails>
                          Total Tracked Hours: {participant.trackedHours}
                        </ParticipantDetails>
                        <ParticipantActions>
                          <Button
                            icon="chat"
                            onClick={() => {
                              callAPI(
                                dispatch,
                                "initializeConversation"
                                // { id: mentee?.participant.id }
                              )
                                .then((res) => {
                                  if (res) {
                                    // navigate(
                                    //   `/messages/${mentee?.participant.uuid}`
                                    // );

                                    navigate(
                                      `/messages/${participant?.participant?.uuid}`
                                    );
                                  }
                                })
                                .catch((error) => {
                                  //console.error(error);
                                });
                            }}
                            // onClick={() => {
                            //   navigate(
                            //     `/messages/${participant?.participant?.uuid}`
                            //   );
                            // }}
                          />
                        </ParticipantActions>
                      </Participant>
                    );
                  })}
              </ParticipantMembers>
            </ListInner>
          </List>
        )}
      </ProfileImageContainer>
    );
  };

  function deleteParticipant(id, userId) {
    callAPI(dispatch, "DeleteMember", {
      id: id,
      pid: +params.selectedProgram,
      userId,
    }).then(() => {
      getMentorParticipantOpenNetworking();
      setActionButtons(null);
    });
  }

  function deactivateUser(id, userId) {
    callAPI(dispatch, "DeactivateProgram", {
      id: id,
      pid: +params.selectedProgram,
      userId,
    }).then(() => {
      getMentorParticipantOpenNetworking();
      setActionButtons(null);
    });
  }

  const [checkboxStates, setCheckboxStates] = useState([]);

  const handleCheckboxChange = (rowId, data) => {
    setCheckboxStates((prevState) => {
      const isChecked = !prevState[rowId]?.checked;

      const updatedState = {
        ...prevState,
        [rowId]: { checked: isChecked, data },
      };

      // Keep only entries where `checked` is true
      const filteredState = Object.fromEntries(
        Object.entries(updatedState).filter(
          ([_, value]) => value.checked === true
        )
      );

      return filteredState;
    });
  };

  const allChecked =
    Object.keys(checkboxStates).length > 0 &&
    Object.keys(checkboxStates).length === mentorParticipant?.length;
  Object.keys(checkboxStates)?.map((ele) => {
    return checkboxStates[ele]?.checked;
  });

  const selectAllHandler = (value) => {
    if (allChecked) {
      setCheckboxStates({});
    } else {
      setCheckboxStates(
        mentorParticipant?.reduce((acc, mentor) => {
          const isChecked = !mentor[mentor?.id]?.checked;

          acc[mentor.id] = { checked: isChecked, data: mentor };
          return acc;
        }, {})
      );
    }
  };

  const clearSelectedHandler = () => {
    setCheckboxStates({});
  };

  const exportDataHandler = () => {
    const baseLabels = ["Full Name", "Role", "Status", "Email"];
    const baseDataKeys = ["fullName", "role", "status", "email"];

    const uniqueQuestionsMap = new Map(); // questionText -> qKey

    const tableData = Object.keys(checkboxStates)
      .map((id) => {
        const data = checkboxStates[id]?.data;
        if (!data) return null;

        // NOTE: PLEASE DO NOT REMOVE THIS
        const queAnsData =
          data?.questionsData?.map((question) => {
            const questionText = question?.questions?.question?.trim();
            if (!questionText) return null;

            if (!uniqueQuestionsMap.has(questionText)) {
              const qKey = `q${uniqueQuestionsMap.size}`;
              uniqueQuestionsMap.set(questionText, qKey);
            }

            // Clean the answer
            let answer = question?.answer;
            if (typeof answer === "string") {
              answer = answer.replace(/[{"}]/g, "").trim();
            }

            const qKey = uniqueQuestionsMap.get(questionText);
            return { [qKey]: answer };
          }) || [];

        const mergedQueAns = Object.assign({}, ...queAnsData);

        return {
          fullName: `${data.participant?.firstName} ${data.participant?.lastName}`,
          role: data?.joinAs,
          status: data.status || "",
          email: data.participant?.email,
          [data?.joinAs === "mentor" ? "mentees" : "mentors"]: data?.mentees
            ? data?.mentees?.length
            : data?.mentors?.length,
          ...mergedQueAns,
        };
        // NOTE: PLEASE DO NOT REMOVE THIS
      })
      .filter(Boolean);

    const questionLabels = Array.from(uniqueQuestionsMap.keys());
    const questionDataKeys = Array.from(uniqueQuestionsMap.values());

    const escapeCSVValue = (value) => {
      if (
        typeof value === "string" &&
        (value.includes(",") || value.includes("\n") || value.includes('"'))
      ) {
        return `"${value.replace(/"/g, '""')}"`; // Escape inner double quotes
      }
      return value;
    };

    const finalLabels = [...baseLabels, ...questionLabels].map(escapeCSVValue);

    ExportCSV({
      // labels: [...baseLabels, ...questionLabels],
      labels: finalLabels,
      dataKeys: [...baseDataKeys, ...questionDataKeys],
      tableData,
      fileName: `Export_Users`,
    });
  };

  const deleteMultipleDataHandler = () => {
    const dataIds = Object.keys(checkboxStates);

    const participantIds = dataIds?.map((id) => {
      return checkboxStates[id]?.data?.participantId;
    });

    callAPI(dispatch, "DeleteMultipleMember", {
      tid: +params.selectedProgram,
      data: [...participantIds],
    }).then(() => {
      getMentorParticipantOpenNetworking();
    });
  };

  const printDataHandler = () => {
    // NOTE: PLEASE DO NOT REMOVE THIS
    // const labels = ["Full Name", "Role", "Status", "Email"];
    // const dataKeys = ["fullName", "role", "status", "email"];
    // NOTE: PLEASE DO NOT REMOVE THIS

    const labels = [
      "Full Name",
      "Ranking",
      joinAs === "mentor" ? "Mentees" : "Mentors",
      "Tracked Hours",
      "Status",
      "Date Joined",
    ];

    const dataKeys = [
      "fullName",
      "ranking",
      joinAs === "mentor" ? "mentees" : "mentors",
      "trackedHours",
      "status",
      "dateJoined",
    ];

    const selectedData = Object.keys(checkboxStates)
      .map((id) => {
        const data = checkboxStates[id]?.data;
        if (!data) return null;

        // NOTE: PLEASE DO NOT REMOVE THIS
        // const queAnsData =
        //   data?.questionsData?.map((question, index) => {
        //     labels.push(question?.questions?.question);
        //     dataKeys.push(`q${index}`);

        //     // Clean the answer: remove braces and quotes
        //     let answer = question?.answer;

        //     if (typeof answer === "string") {
        //       answer = answer.replace(/[{"}]/g, "").trim();
        //     }

        //     return { [`q${index}`]: answer };
        //   }) || [];

        // const mergedQueAns = Object.assign({}, ...queAnsData);

        // return {
        //   fullName:
        //     data.participant?.firstName + " " + data.participant?.lastName,
        //   role: data?.joinAs,
        //   status: data.status || "",
        //   email: data.participant?.email,
        //   ...mergedQueAns,
        // };
        // NOTE: PLEASE DO NOT REMOVE THIS

        return {
          fullName: `${data.participant?.firstName} ${data.participant?.lastName}`,
          ranking: data?.rank,
          [data?.joinAs === "mentor" ? "mentees" : "mentors"]: data?.mentees
            ? data?.mentees?.length
              ? data?.mentees?.length
              : "-"
            : data?.mentors?.length
            ? data?.mentors?.length
            : "-",
          trackedHours:
            data?.totalTrackHours === 0 ? "0" : data?.totalTrackHours,
          status: data?.status || "",
          dateJoined: formatDateForMeetings(data?.dateJoined),
        };
      })
      .filter(Boolean);

    if (selectedData.length === 0) {
      alert("No data to print");
      return;
    }

    const tableHtml = `
    <table>
      <thead>
        <tr>
          ${labels.map((key) => `<th>${key}</th>`).join("")}
        </tr>
      </thead>
      <tbody>
        ${selectedData
          .map(
            (row) => `
          <tr>
            ${dataKeys.map((key) => `<td>${row[key] ?? ""}</td>`).join("")}
          </tr>
        `
          )
          .join("")}
      </tbody>
    </table>
  `;

    const printWindow = window.open("", "", "width=900,height=700");

    const htmlContent = `
    <html>
      <head>
        <title>Print</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }
          table {
            border-collapse: collapse;
            width: 100%;
          }
          th, td {
            border: 1px solid #000;
            padding: 8px;
            text-align: left;
          }
          th {
            background-color: #f0f0f0;
          }
        </style>
      </head>
      <body>
        ${tableHtml}
        <script>
          window.onload = function () {
            window.print();
            window.onafterprint = () => window.close();
          };
        </script>
      </body>
    </html>
  `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  //
  const [openDropdown, setOpenDropdown] = useState(false);
  const [showAggregateModal, setShowAggregateModal] = useState(false);

  const aggregateResponseHandler = () => {
    setShowAggregateModal((prevState) => !prevState);
    setOpenDropdown(false);
  };

  //

  // console.log("mentorParticipant:", mentorParticipant);

  return (
    <>
      {isOpenApplicationModal && applicationModal && (
        <ApplicationModal
          {...{
            applicationModal,
            setApplicationModal,
            setIsOpenApplicationModal,
          }}
        />
      )}

      <MentorsContainerOuter>
        <MentorsHead>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <BackButton onClick={() => setSwitchToParticipants("participants")}>
              <Icon type="back" />
              <ButtonText>Back</ButtonText>
            </BackButton>

            <ExportContainer>
              <Export onClick={() => setOpenDropdown(!openDropdown)}>
                ...
              </Export>
              {openDropdown && (
                <>
                  <ExportOptions>
                    <ExportOption onClick={aggregateResponseHandler}>
                      View Aggregate Responses
                    </ExportOption>
                  </ExportOptions>
                </>
              )}
            </ExportContainer>
          </div>
        </MentorsHead>

        <MentorDescription>
          <MentorsHeading>
            {joinAs === "mentor" ? "Mentors" : "Mentees"}
          </MentorsHeading>
          <MentorsInfo>
            {/* {joinAs === "mentor"
              ? `${participantLength} Active mentors`
              : `${participantLength} Active mentees`} */}
            {joinAs === "mentor"
              ? `${participantLength} mentors`
              : `${participantLength} mentees`}
          </MentorsInfo>
        </MentorDescription>
        <MentorsBottom>
          <div
            style={{
              display: "block",
            }}
          >
            <ExportDeleteBtnContainer
              style={{
                display:
                  Object.keys(checkboxStates).length === 0 ? "none" : "flex",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "4px",
                }}
              >
                <MentorsInfo>
                  {Object.keys(checkboxStates).length + " Selected"}
                </MentorsInfo>
                <button
                  onClick={clearSelectedHandler}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                >
                  {Object.keys(checkboxStates).length > 0 && (
                    <Icon type="cross" size="12" />
                  )}
                </button>
              </div>
              <BackButton
                style={{ padding: "6px" }}
                onClick={exportDataHandler}
              >
                <Icon type="export" />
                <ButtonText>Export</ButtonText>
              </BackButton>
              <BackButton style={{ padding: "6px" }} onClick={printDataHandler}>
                <Icon type="print" />
                <ButtonText>Print</ButtonText>
              </BackButton>
              <BackButton
                style={{ padding: "6px" }}
                onClick={deleteMultipleDataHandler}
              >
                <Icon type="delete" />
                <ButtonText>Delete</ButtonText>
              </BackButton>
            </ExportDeleteBtnContainer>
          </div>

          <SearchBoxFilterContainer>
            <SearchParticipantsWrapper>
              <Icon type="search" />
              <TextInput
                placeholder="Search for Participant"
                value={searchParticipant}
                setValue={setSearchParticipant}
                isSearch={true}
              />
            </SearchParticipantsWrapper>
            <FilterContainer
              disabled={mentorParticipant?.length === 0}
              onMouseEnter={() =>
                mentorParticipant?.length !== 0 && setFilterOptions(true)
              }
              onMouseLeave={() =>
                mentorParticipant?.length !== 0 && setFilterOptions(false)
              }
            >
              <FilterOption>
                <Icon type="filter" />
                <FilterText>Filter</FilterText>
              </FilterOption>
              {filterOptions && (
                <FilterOptions>
                  <FilterHeadText>Filter By</FilterHeadText>
                  <FilterBy>
                    <FilterLabel>
                      <FilterLabelText>Date Range</FilterLabelText>
                      <FilterClear
                        onClick={() => setDateRange({ from: null, to: null })}
                      >
                        Clear
                      </FilterClear>
                    </FilterLabel>
                    <DateInputs>
                      <EnhancedDateRangePicker
                        dateRange={dateRange}
                        setDateRange={setDateRange}
                      />
                    </DateInputs>
                  </FilterBy>
                  <FilterBy>
                    <FilterLabel>
                      <FilterLabelText>Hours Committed</FilterLabelText>
                      <FilterClear
                        onClick={() => {
                          setHourRangeFrom(null);
                          setHourRangeTo(null);
                        }}
                      >
                        Clear
                      </FilterClear>
                    </FilterLabel>
                    <DateInputs>
                      <EnhancedDateRangePicker
                        hours={true}
                        hourRangeTo={hourRangeTo}
                        setHourRangeTo={setHourRangeTo}
                        setHourRangeFrom={setHourRangeFrom}
                        hourRangeFrom={hourRangeFrom}
                      />
                    </DateInputs>
                  </FilterBy>
                  <FilterBy>
                    <FilterLabel>
                      <FilterLabelText>Status</FilterLabelText>
                      <FilterClear onClick={() => setStatus("")}>
                        Clear
                      </FilterClear>
                    </FilterLabel>
                    <Select id="status" value={status} onChange={handleChange}>
                      <Option value="" disabled>
                        Select a status
                      </Option>
                      <Option value="active">Active</Option>
                      <Option value="deactivated">Deactivated</Option>
                    </Select>
                  </FilterBy>
                  <FilterButtons>
                    <ResetButton onClick={resetFilters}>Reset All</ResetButton>
                    <ApplyButton onClick={applyFilters}>
                      {loading ? (
                        <Icon type={"loading"} size="16" color="#ffffff" />
                      ) : (
                        "Apply Filter"
                      )}
                    </ApplyButton>
                  </FilterButtons>
                </FilterOptions>
              )}
            </FilterContainer>
          </SearchBoxFilterContainer>
        </MentorsBottom>

        {mentorParticipant?.length === 0 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <NotFoundMessage>{`No ${
              joinAs === "mentor" ? "Mentor" : "Mentee"
            } Found`}</NotFoundMessage>
          </div>
        ) : (
          <TableContainer>
            <Table
              loader={loading}
              {...{ pageSize, setPageSize, page, setPage }}
              meetingsDashboard={true}
              isApplicants={true}
              meetings={true}
              isActive={true}
              selectAllHandler={selectAllHandler}
              allChecked={allChecked}
              columns={[
                {
                  key: "name",
                  title: "Full Name",
                  checkbox: true,
                  sortable: true,
                  sortValueFn: (row) => {
                    const fullName = `${row?.participant?.firstName ?? ""} ${
                      row?.participant?.lastName ?? ""
                    }`.trim();
                    return fullName.toLowerCase();
                  },
                  render: ({ row }) => {
                    return (
                      <NameContainer>
                        <Checkbox
                          value={!!checkboxStates[row?.id]?.checked}
                          // value={checkboxStates.includes}
                          setValue={(event) =>
                            handleCheckboxChange(row?.id, row)
                          }
                        />
                        <AvatarInfo>
                          <Info nonWidth={true}>
                            {
                              <Avatar
                                leftSpace={1}
                                src={
                                  row?.participant?.image
                                    ? row?.participant?.image
                                    : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                                }
                              />
                            }
                          </Info>
                          <AvatarName>
                            {row?.participant?.firstName +
                              " " +
                              row?.participant?.lastName}
                          </AvatarName>
                        </AvatarInfo>
                      </NameContainer>
                    );
                  },
                },
                {
                  key: "ranking",
                  title: "Ranking",
                  // render: ({ index }) => {
                  // return ranking + index;
                  // },
                  sortable: true,
                  sortValueFn: (row) => row?.rank,
                  render: ({ row }) => {
                    // return ranking + index;
                    // return 1
                    return row?.rank;
                  },
                },

                {
                  key: joinAs === "mentor" ? "mentees" : "mentors",
                  title: joinAs === "mentor" ? "Mentees" : "Mentors",
                  // render: ({ row }) => {
                  //   return (
                  //     <ParticipantList
                  //       participant={row.mentees ? row.mentees : row.mentors}
                  //       participantClicked={row}
                  //       participantClickedId={row.id}
                  //     />
                  //   );
                  // },
                  render: ({ row }) => {
                    const participantsArray = row.mentees ?? row.mentors ?? [];
                    const limitedParticipants =
                      participantsArray.length > 5
                        ? participantsArray.slice(0, 5)
                        : participantsArray;

                    return (
                      <ParticipantList
                        participant={limitedParticipants}
                        totalParticipants={participantsArray}
                        participantClicked={row}
                        participantClickedId={row.id}
                      />
                    );
                  },
                },
                {
                  key: "trackedHours",
                  title: "Tracked Hours",
                  sortable: true,
                  sortValueFn: (row) => row?.totalTrackHours,
                  render: ({ row }) => {
                    return row?.totalTrackHours;
                  },
                },

                {
                  key: "status",
                  title: "Status",
                  render: ({ row }) => {
                    return row.status;
                  },
                },
                {
                  key: "date",
                  title: "Date Joined",
                  sortable: true,
                  sortValueFn: (row) => row?.dateJoined,
                  render: ({ row }) => {
                    return (
                      <DateTag>
                        {formatDateForMeetings(row?.dateJoined)}
                      </DateTag>
                    );
                  },
                },
                {
                  key: "",
                  title: "Actions",
                  render: ({ row }) => {
                    return (
                      <TableActions isActive={true}>
                        <div
                          onMouseEnter={() => setActionButtons(row.id)}
                          onMouseLeave={() => setActionButtons(null)}
                        >
                          <DropIcon>
                            <Icon type="dropdown-dots" />
                          </DropIcon>

                          {actionButtons === row.id && (
                            <DropdownItems>
                              <DropdownButton
                                meetings={true}
                                onClick={() => {
                                  setApplicationModal(row);
                                  setIsOpenApplicationModal(true);
                                }}
                              >
                                View Application
                              </DropdownButton>
                              <DropdownButton
                                onClick={() =>
                                  deactivateUser(row.id, row.participantId)
                                }
                                meetings={true}
                                variant="secondary"
                              >
                                {row?.status === "active"
                                  ? "Deactivate"
                                  : "Activate"}
                              </DropdownButton>

                              <DropdownButton
                                meetings={true}
                                variant="secondary"
                                onClick={() =>
                                  deleteParticipant(row.id, row.participantId)
                                }
                              >
                                Delete
                              </DropdownButton>
                            </DropdownItems>
                          )}
                        </div>
                      </TableActions>
                    );
                  },
                },
              ]}
              rows={mentorParticipant && mentorParticipant}
            />
            {/* pagination */}
            <TablePagination>
              <div>
                <ResultsLabel>
                  Results per page:
                  <ResultsSelect
                    value={pageSize}
                    onChange={(e) => setPageSize(e.target.value)}
                  >
                    {[5, 10, 15, 20].map((size) => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
                  </ResultsSelect>
                </ResultsLabel>
              </div>
              <PaginationButtons>
                <PaginationSpan>
                  <CurrentPage>{page}</CurrentPage> out of{" "}
                  {count === 0 ? count + 1 : Math.ceil(count / pageSize)}
                </PaginationSpan>
                <PreviousButton
                  onClick={() => page !== 1 && setPage(page - 1)}
                  disabled={page === 1}
                >
                  <AngleSpan>{"<"}</AngleSpan> Previous
                </PreviousButton>

                <NextButton
                  onClick={() =>
                    page !== Math.ceil(count / pageSize) && setPage(page + 1)
                  }
                  disabled={page === Math.ceil(count / pageSize)}
                >
                  Next <AngleSpan next={true}>{">"}</AngleSpan>
                </NextButton>
              </PaginationButtons>
            </TablePagination>
          </TableContainer>
        )}
      </MentorsContainerOuter>

      {showAggregateModal && (
        <AggregatorModal
          title={joinAs === "mentor" ? "Mentors" : "Mentees"}
          joinAs={joinAs}
          setModal={setShowAggregateModal}
        />
      )}
    </>
  );
};

export default Mentors;
